/* eslint-disable no-underscore-dangle */

import axios, { CancelToken } from 'axios';
import StandUtils from '../utils/standUtils';

const standApiPath = StandUtils.getApiPath();
const standBasePath = StandUtils.getBasePath();

let authToken = null;
let authKey = null;

const getRequestHeaders = async () => {
  if (!authToken) {
    const tokenResult = await axios.post(`${standApiPath}/auth/tokens`);

    authToken = tokenResult.data.authToken;
    authKey = tokenResult.data.authKey;
  }

  return {
    authToken
  };
};

const getRequestConfig = async config => {
  const headers = await getRequestHeaders();

  return {
    headers,
    ...config
  };
};

const get = async (url, params) => {
  const requestConfig = await getRequestConfig({ params });

  const result = await axios.get(`${standApiPath}${url}`, requestConfig);
  return result.data;
};

const post = async (url, data, config) => {
  const requestConfig = await getRequestConfig(config);

  const result = await axios.post(`${standApiPath}${url}`, data, requestConfig);
  return result.data;
};

const put = async (url, data, config) => {
  const requestConfig = await getRequestConfig(config);

  const result = await axios.put(`${standApiPath}${url}`, data, requestConfig);
  return result.data;
};

const remove = async (url, params) => {
  const requestConfig = await getRequestConfig({ params });

  const result = await axios.delete(`${standApiPath}${url}`, requestConfig);
  return result.data;
};

const getAuthToken = () => authToken;
const getAuthKey = () => authKey;

const getCancelToken = () => CancelToken.source();

const redirect = async (url) => {
  window.location = `${standBasePath}/${url}`;
};

const HttpService = {
  get,
  post,
  put,
  remove,

  getAuthToken,
  getAuthKey,

  getCancelToken,

  redirect
};

export default HttpService;



// WEBPACK FOOTER //
// ./src/services/httpService.js